import {Inject, Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {SESSION_STORAGE, WebStorageService} from 'ngx-webstorage-service';
import {CookieService} from 'ngx-cookie-service';
import {OidcSecurityService} from "angular-auth-oidc-client";
import {catchError} from "rxjs/operators";
import {of, throwError} from "rxjs";
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class KioskApiService {

  developingMode = false;
  api = 'https://app.kiosk.medis.land';
  currentDirection = 'rtl';

  constructor(private http: HttpClient,
              @Inject(SESSION_STORAGE) private session: WebStorageService,
              private cookieService: CookieService,
              private router: Router,
              public oidcSecurityService: OidcSecurityService) {
    if (this.developingMode) {
      this.api = '';
    }
  }

  onSetLanguage(language, lan_id) {
    this.cookieService.set('dir', language);
    this.cookieService.set('lang', lan_id);
  }

  apiCall(method, route, body) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      lang: this.cookieService.get('lang'),
      // Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    if (method == 'post') {
      return this.http.post(this.api + route, body, {headers});
    } else if (method == 'get') {
      return this.http.get(this.api + route, {headers});
    } else if (method == 'delete') {
      return this.http.delete(this.api + route, {headers});
    } else if (method == 'put') {
      return this.http.put(this.api + route, body, {headers});
    }
  }

  sendFile(route, formData) {
    const headers= new HttpHeaders({
      'encrypt': 'multipart/form-data',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    return this.http.post(this.api + route , formData ,  
      {headers, observe: 'response'}).pipe(
      catchError(error => {
        // console.log(error)
        if (error.status == 403) {
          this.router.navigate(['']);
        }
        return of([]);
      })
    )
  }   

  handleError(error: any) {
    console.log('lalalalalalalala', error.status);
    if (error.status == 401) {
    }

    return throwError(error);
  }
}
